export const SIZE_TEXT = "size";
export const SORT_TEXT = "sort";
export const COLORS_TEXT = "colors";
export const FILTERS_HEADING = "Filters & Sort By";
export const PRIMARY_BUTTON_TEXT = "View Results";
export const TERTIARY_BUTTON_TEXT = "Clear All";

export const SINGLE_SELECT_FILTERS = ["sort", "price"];

export const ASC_ORDER = { slug: "ASC", key: "order" };
export const DESC_ORDER = { slug: "DESC", key: "order" };

export const BRAND_NAMES = {
    35: "Sagaform",
    36: "OFS",
    37: "Common Good",
    38: "new check",
    39: "WEAR THAT",
    40: "SELECTED FEMME",
    41: "IMPERIAL",
    42: "Ted Baker",
    43: "Amen",
    44: "ELLIATT",
    45: "AGUA BENDITA",
    46: "ANAMNESI",
    47: "DR. MARTENS",
    48: "& OTHER STORIES",
    49: "Figleaves",
    50: "CHLOE",
    51: "ACLER",
    52: "BISHOP & YOUNG",
    53: "Bonelement",
    54: "SCHUTZ",
    55: "MANGO",
    56: "AZULU",
    57: "FREE PEOPLE",
    58: "SERENA X RAMADAN",
    59: "Bô collab",
    60: "TUTTI AND CO",
    61: "SERENA X BASMA",
    62: "SERENA X TAMARA",
    63: "SOPHIE RUE",
    64: "SERENA",
    65: "ANGELS EYE",
    66: "SERENA X JESSIE",
    67: "ANGEL SUNGLASSES",
    68: "HOUSE OF BALLERINAS",
    69: "LILA",
    70: "SERENA X BY THE SEA",
    71: "SHONA JOY",
    72: "RAILS",
    73: "MOSSMAN",
    74: "Line And Dot",
    75: "CAMI NYC",
    76: "MON RENN",
    77: "ASTR",
    78: "FARM RIO",
    79: "SANCTUARY",
    80: "PISTOLA",
    81: "BARDOT",
    82: "GOLDIE",
    83: "SOVERE",
    84: "EN SAISON",
    85: "DAMSON MADDER",
    86: "VOKZAL OSMAMBEY",
    87: "SERENA X FALL",
    94: "WEAR THAT X SOHA",
    96: "WEAR THAT X TAMARA",
    97: "WEAR THAT X MARAM",
};

export const FILTERS_TO_MAP = {
    "trending-desc": "TRENDING",
    "latest-desc": "NEWEST",
    "price-asc": "LOWEST PRICE",
    "price-desc": "HIGHEST PRICE",
    null: "RELEVANCE",
    shortDress: "Short Dress",
    longDress: "Long Dress",
    serenaRamadan: "Serena",
    basma: "Basma Collection",
    98: "Accessories",
    83: "Dresses",
    92: "Jewellery",
    81: "Jumpsuits / Playsuits",
    96: "Outerwear",
    24: "Shop All",
    66: "Tops",
    79: "Trousers",
    100: "Basma Collection",
    101: "Serena Ramadan Collection",
    106: "Tamara Collection",
    108: "Serena Collection",
    117: "The Monochrome Shop",
    118: "Your Capsule Collection",
    92: "Jewellery",
    99: "Hair Accessory",
    121: "Sunglasses",
    122: "Scarf",
    131: "Belt",
    142: "Brooch",
    138: "Flat",
    66: "Tops",
    79: "Trousers",
    81: "Jumpsuits / Playsuits",
    83: "Dresses",
    96: "Outerwear",
    111: "Shorts",
    113: "Skirts",
    132: "Bags",
    139: "Swimwear",
    145: "Jeans",
    154: "Knits",
    "[0,250]": "0 - 250 AED",
    "[250,500]": "250 - 500 AED",
    "[500,750]": "500 - 750 AED",
    "[750,1000]": "750 - 1000 AED",
    "[1000,100000]": "1000+ AED",
};

export const SLUGS_TO_IGNORE = [
    undefined,
    "100",
    "101",
    "103",
    "106",
    "108",
    "117",
    "118",
    "120",
    "123",
    "124",
    "125",
    "126",
    "127",
    "135",
    "136",
    "148",
    "162",
    "163",
    "164",
    "171",
    "176",
    "177",
    "178",
    "179",
];
